export const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

export function isZipValid(zip) {
  return ZIP_REGEX.test((zip || '').trim());
}
